import React from "react";
import { SVGInterface } from "../interface";
import * as Images from "../index";
import { SVG_NAMES } from "./constants";

interface GetSVGInterface extends SVGInterface {
  size?: 12 | 16 | 20 | 24;
  svgName?: any;
  onClick?: any;
}

export const GetSVG = ({
  size,
  color,
  className,
  svgName,
  width,
  height,
  ...rest
}: GetSVGInterface) => {
  const getSize = () => {
    switch (size) {
      case 12:
        return 12;

      case 20:
        return 20;

      case 24:
        return 24;

      default:
        return 16;
    }
  };

  const SVG_IMAGES: any = Images;
  const name = svgName?.toUpperCase();
  const SVG = SVG_IMAGES[SVG_NAMES[`${name}`]];
  return SVG ? (
    <SVG
      color={color}
      className={className}
      width={width || getSize()}
      height={height || getSize()}
      style={{ minWidth: width || getSize() }}
      data-testid={`svg-test-id-${svgName}`}
      {...rest}
    />
  ) : null;
};
